
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { ItemListVariazioneOrdineMTM } from '@/components';
import { ConfermaVariazioneSubArrayMTMRequest, MisuraClienteMTM } from '@/models';

@Component({
    components:{
        ItemListVariazioneOrdineMTM
    }
})
export default class ItemListMisuraCliente extends Vue {
    @Prop() private misura!: MisuraClienteMTM;

    get hasVariazioni()
    {
        return (this.misura.variazioni?.length || 0) > 0;
    }
    get headerStyle()
    {
        if(this.showVariazioni){
            return '#f2f2f2';
        } else{
            return '#ffffff';
        }
    }
    private showVariazioni: boolean = false;

    private toggleshowVariazioni()
    {
        if(this.misura.variazioni && this.misura.variazioni.length > 0){
            this.showVariazioni = ! this.showVariazioni;
        }
    }

    @Emit("conferma-variazione")
    private confermaVariazione(variazioneId: string)
    {
        return {
            idSubArrayElement: this.misura.nomeMisura,
            idVariazione: variazioneId,
            idOrdine: "",
            idFornitore: "",
        } as ConfermaVariazioneSubArrayMTMRequest;
    }
}
